/* Shared: derive live-search filters from a collection handle.
   Used by the collection live search (diamond-search.js preset) and kept in one
   place so the two never disagree.
     round-diamonds            -> shape
     1-carat-diamonds          -> carat band
     round-1-carat-diamonds    -> shape + carat
     colorless-vvs-diamonds    -> colour band + clarity band
     d-vs1-diamonds            -> exact colour + clarity
   Thematic handles (engagement, gifts, ...) yield {} = unfiltered. */
(function () {
  var SHAPES = ['round','oval','emerald','cushion','pear','princess','radiant','marquise','asscher','heart'];
  var CLARITIES = ['fl','if','vvs1','vvs2','vs1','vs2','si1','si2'];
  var COLORS = ['d','e','f','g','h','i','j','k','l','m','n'];
  var BANDS = [[0.4,0.49],[0.5,0.59],[0.6,0.69],[0.7,0.79],[0.8,0.89],[0.9,0.99],
               [1.0,1.19],[1.2,1.49],[1.5,1.99],[2.0,2.99],[3.0,3.49]];
  var COLOR_BANDS = { colorless: ['D','E','F'], 'near-colorless': ['G','H'] };
  var CLARITY_BANDS = { vvs: ['VVS1','VVS2'], vs: ['VS1','VS2'], si: ['SI1'] };

  function filtersFromHandle(h) {
    // "0-5-carat" means 0.5 carat — rejoin split decimals before tokenising.
    var t = h.replace(/-/g, ' ').replace(/(\d) (\d)/g, '$1.$2').toLowerCase();
    var f = {};

    var m = t.match(/(\d+(?:\.\d+)?)\s*carat/);
    if (m) {
      var n = parseFloat(m[1]);
      for (var i = 0; i < BANDS.length; i++) {
        if (n >= BANDS[i][0] - 0.001 && n <= BANDS[i][1]) { f.caratMin = BANDS[i][0]; f.caratMax = BANDS[i][1]; break; }
      }
      t = t.replace(m[0], ' ');
    }

    // colour/clarity BANDS first ("near colorless vvs"), they consume two words
    var band = t.match(/near colorless|colorless/);
    if (band && COLOR_BANDS[band[0].replace(/\s+/g, '-')]) {
      f.color = COLOR_BANDS[band[0].replace(/\s+/g, '-')].join(',');
      t = t.replace(band[0], ' ');
    }
    Object.keys(CLARITY_BANDS).forEach(function (k) {
      if (!f.clarity && new RegExp('\\b' + k + '\\b').test(t)) f.clarity = CLARITY_BANDS[k].join(',');
    });

    var tokens = t.split(/[^a-z0-9.]+/).filter(Boolean);
    var shapes = [], clar = [], cols = [];
    tokens.forEach(function (tok) {
      if (SHAPES.indexOf(tok) > -1) shapes.push(tok.toUpperCase());
      else if (CLARITIES.indexOf(tok) > -1) clar.push(tok.toUpperCase());
      else if (tok.length === 1 && COLORS.indexOf(tok) > -1) cols.push(tok.toUpperCase());
    });
    if (shapes.length) f.shape = shapes.join(',');
    if (clar.length && !f.clarity) f.clarity = clar.join(',');
    if (cols.length && !f.color) f.color = cols.join(',');
    return f;
  }

  window.vaalbergHandleFilters = filtersFromHandle;
})();
